import { ReferenceArrayField, SingleFieldList, ChipField } from 'react-admin';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { Draggable } from '@hello-pangea/dnd';


const TaskCard = ({ data, position }) => {
    return (
        <Draggable draggableId={String(data.id)} index={position}>
            {(provided, snapshot) => (

                <Box
                    sx={{ marginBottom: 1 }}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}
                >
                    <Card
                        sx={{
                            opacity: snapshot.isDragging ? 0.9 : 1,
                            transform: snapshot.isDragging ? 'rotate(-2deg)' : '',
                            cursor: 'pointer'
                        }}
                        elevation={snapshot.isDragging ? 3 : 1}
                    >
                        <CardContent>
                            <Typography variant="h5" component="div">
                                {data.description}
                            </Typography>
                            <Typography variant="body2">{data.notes}</Typography>

                            <Box sx={{ marginTop: 2 }}>
                                <ReferenceArrayField record={data} source="user_ids" reference="users" label="Users">
                                    <SingleFieldList sx={{ gap: '5px' }}>
                                        <ChipField source="trigram" variant="outlined" size="small" />
                                    </SingleFieldList>
                                </ReferenceArrayField>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            )}
        </Draggable>
    );
};

export default TaskCard;